var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"alert-fade"}},[(_vm.open)?_c('div',{class:['notification', ("is-" + _vm.type)]},[(_vm.dismissable)?_c('button',{staticClass:"delete",on:{"click":_vm.onCloseClicked}}):_vm._e(),_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }